const api = '/item-service/api/external';
const characteristics = `${api}/characteristics`;

export const characteristicsContext = {
  all: characteristics,
  byId: `${characteristics}/{id}`,
  units: `${api}/units`,
  options: {
    all: `${characteristics}/{id}/options`,
    byId: `${characteristics}/options/{id}`,
  },
};
